import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi) // Loads translations from /public/locales
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    supportedLngs: ['en', 'es'], // Add all supported languages here
    fallbackLng: 'en', // Default language if current language translation is missing
    defaultNS: 'translation', // Default namespace for translations
    // lng: 'en', // You can set a default language here if not using LanguageDetector

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
    },

    interpolation: {
      escapeValue: false, // React already safes from xss
    },

    // React-specific options
    react: {
      useSuspense: true, // Recommended for loading translations
    },

    // Optional: Enable debug mode for development
    // debug: process.env.NODE_ENV === 'development',
  });

export default i18n; 